import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {ThemeProvider, Box} from '@mui/material';
import NavBar from '../../../pieces/navbar/navbar';
import myTheme from '../../../styles/myStyles';
import DisplayListsPageWrapper from '../../wrappers/displayListsPageWrapper';
import ListPageHeader from '../../../pieces/listPageHeader';
import {ListViewHeader} from '../../jobs/components/listViewHeader';
import usePagination from '../../../hooks/usePagination';
import {useGridViewState} from '../../../hooks/useGridViewState';
import base_url from '../../../baseUrls';
import AiAgentsGrid, {getAiAgentsGridAdditionalButtons} from './aiAgentsGrid';

export const AiAgents = () => {
  const viewController = useGridViewState();
  const pagination = usePagination();
  const user = useSelector((state) => state.user);


  const fetchParams = useMemo(
    () => ({
      url: `${base_url.api}users/get-ai-agents`,
      respKey: 'users',
      options: {},
    }),
    [user?.viewAgentAiCall, user?.agentId],
  );

  const getHeaderComponent = () => {
    let title = 'AI Call Agents';
    if (pagination.totalItemsCount) {
      title = `${title} (${pagination.totalItemsCount})`;
    }
    return (
      <ListViewHeader
        title={title}
        pagination={pagination}
        viewController={viewController}
      />
    );
  };

  const headerComponent = (
    <ListPageHeader
      viewController={viewController}
      headComponent={getHeaderComponent()}
      showAddButton={false}
      totalItems={pagination.totalItemsCount}
      additionalButtons={getAiAgentsGridAdditionalButtons(viewController)}
    >
      {pagination.ItemsController}
    </ListPageHeader>
  );

  return viewController.RenderElement(
    <>
      <NavBar />
      <ThemeProvider theme={myTheme}>
        <Box sx={{height: '100%'}}>
          <DisplayListsPageWrapper headerComponent={headerComponent}>
            <AiAgentsGrid viewController={viewController} pagination={pagination} fetchParams={fetchParams} />
            {pagination.PageController}  
          </DisplayListsPageWrapper>
        </Box>
      </ThemeProvider>
    </>,
  );
};
